import { UserOutlined } from '@ant-design/icons';
import { useUnmount } from 'ahooks';
import {
  Col,
  notification,
  Row,
  Space,
} from 'antd';
import dayjs from 'dayjs';
import { toLower, upperFirst } from 'lodash';

import { CompleteProcessingButton } from './CompleteProcessingButton';
import { DescalateButton } from './DescalateButton';
import { EscalateButton } from './EscalateButton';
import { FraudButton } from './FraudButton';
import { NextSnapButton } from './NextSnapButton';
import { NotDuplicateButton } from './NotDuplicateButton';
import { ReprocessButton } from './ReprocessButton';

import { snapStore } from '../../store';

export const SnapActions = () => {
  const processingByOpsUserId = snapStore((state) => state.processingByOpsUserId);
  const processingByOpsUserRole = snapStore((state) => state.processingByOpsUserRole);
  const processingByOpsUserEmail = snapStore((state) => state.processingByOpsUserEmail);
  const processingByOpsUserIdStartedAt = snapStore((state) => state.processingByOpsUserIdStartedAt);

  useUnmount(() => {
    notification.destroy('complete-error');
    notification.destroy('complete-success');
  });

  return (
    <Row justify='space-between' align='middle'>
      <Col className='pl-10'>
        {!!processingByOpsUserId && (
          <Row align='middle'>
            <div className='mr-5 h-[25px] w-[25px] bg-[#E1E1E1] flex justify-center align-middle border-r-5 rounded-full'>
              <UserOutlined />
            </div>

            <span className='mr-5'>
              {upperFirst(toLower(processingByOpsUserRole))}
              {' '}
              ID
              {' '}
              {processingByOpsUserId}
              {`(${processingByOpsUserEmail})`}
            </span>

            In process from
            {' '}
            {dayjs(processingByOpsUserIdStartedAt).format('DD/MM/YYYY hh:mm A')}
          </Row>
        )}
      </Col>

      <Col>
        <Space size={10}>
          <ReprocessButton />

          <CompleteProcessingButton />

          <EscalateButton />

          <DescalateButton />

          <NotDuplicateButton />

          <NextSnapButton />

          <FraudButton />
        </Space>
      </Col>
    </Row>
  );
};
